module.exports = __webpack_public_path__ + "static/favicon-cef8702d7956258801f2c86c16c0939a.png";